import React from "react";

/**
 * @component ArrowBackMobileIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowBackMobileIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowBackMobileIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ArrowBackMobileIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.293 4.222a1 1 0 011.492 1.327l-.078.087L9.343 12l6.364 6.364a1 1 0 01.078 1.327l-.078.087a1 1 0 01-1.327.078l-.087-.078-7.071-7.07a1 1 0 01-.078-1.328l.078-.087 7.07-7.071z"
      />
    </svg>
  )
);
ArrowBackMobileIcon.displayName = "ArrowBackMobileIcon";
export default ArrowBackMobileIcon;
